import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from '@material-ui/core/Table';
import TableHead from './TableHead/TableHead';
import TableBody from './TableBody/TableBody';
import LoadingTable from './LoadingTable/LoadingTable';

const Table = ({
    headData,
    onSortTable,
    sortParameters,
    isFetching,
    bodyData,
    EmptyTableComponent,
    handleRowClick
}) => {
    const { sortField, sortOrder } = sortParameters;
    const isEmpty = bodyData.length === 0;

    return (
        <React.Fragment>
            <MaterialTable>
                <TableHead
                    columns={headData}
                    onSortTable={onSortTable}
                    sortField={sortField}
                    sortOrder={sortOrder}
                />
                {
                    !isEmpty &&
                        <TableBody
                            rows={bodyData}
                            onClickRow={handleRowClick}
                        />
                }
            </MaterialTable>
            {
                isEmpty && (isFetching ?
                    <LoadingTable rowsNumber={9}/> :
                    <EmptyTableComponent />
                )
            }
        </React.Fragment>
    );
};

Table.propTypes = {
    headData: PropTypes.arrayOf(PropTypes.object),
    onSortTable: PropTypes.func,
    sortParameters: PropTypes.object,
    isFetching: PropTypes.bool,
    bodyData: PropTypes.arrayOf(PropTypes.object),
    EmptyTableComponent: PropTypes.func,
    handleRowClick: PropTypes.func
};

export default Table;
